// eslint-disable-next-line import/no-cycle
import { getUserData } from '@/auth/utils'
import { USER_TYPE_DISTRICT } from '@/const/userType'

export default function districtUsersOnly({ next, router }) {
  if (getUserData().usertype !== USER_TYPE_DISTRICT && getUserData().usertype !== 'super') {
    return router.push('not-authorized')
  }

  return next()
}
